<template>
  <div class="log-page">
    <van-nav-bar left-arrow class="crystal-nav" @click-left="gotohome">
      <template #left>
        <van-icon name="arrow-left" size="20px" color="#475569" />
      </template>
      <template #title>
        <span class="nav-title">{{ udname }} - 历史记录</span>
      </template>
    </van-nav-bar>

    <van-tabs v-model="activeTab" color="#2dd4bf" title-active-color="#0d9488" class="crystal-tabs">
      <van-tab title="全部">
        <div class="tab-content">
          <div v-if="logs.length === 0" class="empty-state">
            <span class="iconfont icon-rizhi empty-icon"></span>
            <div class="empty-text">暂无记录</div>
          </div>
          <div v-for="(row, index) in logs" :key="'all' + index" class="log-card">
            <div class="log-body">
              <div class="log-row">
                <span class="log-label">事件</span>
                <span class="log-value" :class="logColorClass(row.name)">{{ logName(row.name) }}</span>
              </div>
              <div v-if="logVal(row)" class="log-row">
                <span class="log-label">详情</span>
                <span class="log-value">{{ logVal(row) }}</span>
              </div>
              <div class="log-row log-row--last">
                <span class="log-label">时间</span>
                <span class="log-value">{{ row.time }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>

      <van-tab title="换水记录">
        <div class="tab-content">
          <div v-if="tabLogs('wc').length === 0" class="empty-state">
            <span class="iconfont icon-huanshui empty-icon"></span>
            <div class="empty-text">暂无换水记录</div>
          </div>
          <div v-for="(row, index) in tabLogs('wc')" :key="'wc' + index" class="log-card">
            <div class="log-body">
              <div class="log-row">
                <span class="log-label">事件</span>
                <span class="log-value" :class="logColorClass(row.name)">{{ logName(row.name) }}</span>
              </div>
              <div v-if="logVal(row)" class="log-row">
                <span class="log-label">详情</span>
                <span class="log-value">{{ logVal(row) }}</span>
              </div>
              <div class="log-row log-row--last">
                <span class="log-label">时间</span>
                <span class="log-value">{{ row.time }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>

      <van-tab title="补水记录">
        <div class="tab-content">
          <div v-if="tabLogs('fill').length === 0" class="empty-state">
            <span class="iconfont icon-bushuitubiao empty-icon"></span>
            <div class="empty-text">暂无补水记录</div>
          </div>
          <div v-for="(row, index) in tabLogs('fill')" :key="'fill' + index" class="log-card">
            <div class="log-body">
              <div class="log-row">
                <span class="log-label">事件</span>
                <span class="log-value" :class="logColorClass(row.name)">{{ logName(row.name) }}</span>
              </div>
              <div v-if="logVal(row)" class="log-row">
                <span class="log-label">详情</span>
                <span class="log-value">{{ logVal(row) }}</span>
              </div>
              <div class="log-row log-row--last">
                <span class="log-label">时间</span>
                <span class="log-value">{{ row.time }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>

      <van-tab title="维护记录">
        <div class="tab-content">
          <div v-if="tabLogs('maint').length === 0" class="empty-state">
            <span class="iconfont icon-gongzuomoshi empty-icon"></span>
            <div class="empty-text">暂无维护记录</div>
          </div>
          <div v-for="(row, index) in tabLogs('maint')" :key="'maint' + index" class="log-card">
            <div class="log-body">
              <div class="log-row">
                <span class="log-label">事件</span>
                <span class="log-value" :class="logColorClass(row.name)">{{ logName(row.name) }}</span>
              </div>
              <div v-if="logVal(row)" class="log-row">
                <span class="log-label">详情</span>
                <span class="log-value">{{ logVal(row) }}</span>
              </div>
              <div class="log-row log-row--last">
                <span class="log-label">时间</span>
                <span class="log-value">{{ row.time }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>

      <van-tab title="故障记录">
        <div class="tab-content">
          <div v-if="tabLogs('fault').length === 0" class="empty-state">
            <span class="iconfont icon-gongju empty-icon"></span>
            <div class="empty-text">暂无故障记录</div>
          </div>
          <div v-for="(row, index) in tabLogs('fault')" :key="'fault' + index" class="log-card">
            <div class="log-body">
              <div class="log-row">
                <span class="log-label">事件</span>
                <span class="log-value" :class="logColorClass(row.name)">{{ logName(row.name) }}</span>
              </div>
              <div v-if="logVal(row)" class="log-row">
                <span class="log-label">详情</span>
                <span class="log-value">{{ logVal(row) }}</span>
              </div>
              <div class="log-row log-row--last">
                <span class="log-label">时间</span>
                <span class="log-value">{{ row.time }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
const LOG_MAP = {
  boot:        { name: "开机",           tone: "inactive" },
  time_sync:   { name: "时间同步",       tone: "inactive" },
  wc_start:    { name: "换水开始",       tone: "active" },
  wc_done:     { name: "换水完成",       tone: "ok" },
  wc_stop:     { name: "换水停止",       tone: "warn" },
  wc_skip:     { name: "低水位跳过换水", tone: "warn" },
  md_start:    { name: "手动排水开始",   tone: "active" },
  md_done:     { name: "手动排水完成",   tone: "ok" },
  md_cancel:   { name: "排水取消",       tone: "warn" },
  md_reject:   { name: "排水被拒绝",     tone: "inactive" },
  mf_start:    { name: "手动补水开始",   tone: "active" },
  mf_done:     { name: "手动补水完成",   tone: "ok" },
  mf_reject:   { name: "补水被拒绝",     tone: "inactive" },
  evap_start:  { name: "独立补水开始",   tone: "active" },
  evap_done:   { name: "独立补水完成",   tone: "ok" },
  evap_skip:   { name: "独立补水跳过",   tone: "warn" },
  drain_done:  { name: "排水完成",       tone: "ok" },
  maint_in:    { name: "进入维护",       tone: "warn" },
  maint_out:   { name: "退出维护",       tone: "ok" },
  fault:       { name: "故障",           tone: "warn" },
  fault_add:   { name: "附加故障",       tone: "warn" },
  fault_clear: { name: "故障清除",       tone: "ok" },
  save_fail:   { name: "参数保存失败",   tone: "warn" },
};

const FAULT_NAMES = [
  "",
  "水位传感器异常",       // 1 APP_ERR_LEVEL_BAD
  "排水超时",             // 2 APP_ERR_DRAIN_TIMEOUT
  "换水补水超时",         // 3 APP_ERR_WC_FILL_TIMEOUT
  "手动/独立补水超时",    // 4 APP_ERR_FILL_TIMEOUT
  "程序输出互锁异常",     // 5 APP_ERR_INTERLOCK
];

/* 日志 val 枚举汉化（app_business.c s_log 实际取值，§19.1） */
const LOG_VAL_MAP = {
  boot:        { "power_on": "正常开机", "abnormal": "异常重启", "ok": "校准完成" },
  wc_start:    { "auto": "自动启动" },
  wc_stop:     { "user": "用户停止" },
  wc_skip:     { "low_level": "低水位" },
  md_start:    { "manual": "手动启动" },
  md_cancel:   { "low": "低水位" },
  md_reject:   { "low": "低水位拒绝" },
  mf_start:    { "manual": "手动启动" },
  mf_reject:   { "full": "满水拒绝" },
  evap_start:  { "check": "定时检查启动" },
  evap_skip:   { "full": "满水跳过" },
  maint_in:    { "": "手动进入" },
  maint_out:   { "timeout": "超时自动退出", "manual": "手动退出" },
  time_sync:   { "": "时间已同步" },
  fault_clear: { "": "已清除" },
};

export default {
  name: "KD4Log",
  data() {
    return {
      udname: this.$route.query.udname || "",
      did: this.$route.query.did,
      activeTab: 0,
      logs: [],
    };
  },
  mounted() {
    if (!this.udname) {
      this.GetDevName(this.did);
    }
    this.GetHistory();
  },
  methods: {
    gotohome() {
      this.$router.go(-1);
    },
    GetDevName(did) {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/one", qs.stringify({ did: did }))
        .then((response) => {
          if (response.data.error_code === 0) {
            this.udname = response.data.udname;
          }
        });
    },
    GetHistory() {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/history", qs.stringify({ did: this.did, dtype: "KD-4", history: "log", tnum: 7, tunit: "day" }))
        .then((response) => {
          if (response.data.error_code === 0) {
            const buf = response.data.data.log_buf;
            this.logs = Array.isArray(buf) ? buf : [];
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$toast.fail("获取日志失败(" + response.data.error_code + ")");
          }
        })
        .catch((error) => {
          this.$toast.fail("获取日志失败");
        });
    },
    logName(name) {
      const m = LOG_MAP[name];
      return m ? m.name : name;
    },
    /* 事件名颜色：完成=青 / 异常故障=红 / 其他默认（同 KD-3 log-value 风格） */
    logColorClass(name) {
      const m = LOG_MAP[name];
      if (!m) return "";
      if (m.tone === "ok") return "value-ok";
      if (m.tone === "warn") return "value-warn";
      return "";
    },
    logVal(row) {
      if (row.name === "fault" || row.name === "fault_add") {
        /* val 格式「码@阶段」：解析故障码与发生阶段 */
        var parts = String(row.val || "").split("@");
        var code = parseInt(parts[0], 10) || 0;
        var name = code > 0 && code < FAULT_NAMES.length ? FAULT_NAMES[code] : String(row.val);
        return parts.length > 1 && parts[1] !== "" ? name + "（阶段" + parts[1] + "）" : name;
      }
      if (row.name === "drain_done") {
        const v = row.val;
        if (v === "unmeasured") return "水量未统计";
        const ml = parseInt(v, 10);
        if (!isNaN(ml) && ml >= 0) return (ml / 1000).toFixed(2) + " L";
        return v;
      }
      /* 枚举值汉化，未匹配时原样显示 */
      const m = LOG_VAL_MAP[row.name];
      if (m && m[String(row.val)] != null) return m[String(row.val)];
      return row.val || "";
    },
    tabLogs(kind) {
      const kinds = {
        wc: ["wc_start", "wc_done", "wc_stop", "wc_skip"],
        fill: ["md_start", "md_done", "md_cancel", "md_reject", "mf_start", "mf_done", "mf_reject", "evap_start", "evap_done", "evap_skip", "drain_done"],
        maint: ["maint_in", "maint_out"],
        fault: ["fault", "fault_add", "fault_clear"],
      };
      const list = kinds[kind] || [];
      return this.logs.filter((row) => list.indexOf(row.name) >= 0);
    },
  },
};
</script>

<style>
.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  max-width: 70vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.crystal-tabs .van-tabs__wrap {
  background: #ffffff;
}

.crystal-tabs .van-tab {
  font-weight: 500;
}
</style>

<style scoped>
.log-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f8fafc;
}

.tab-content {
  padding: 12px;
  height: calc(100vh - 92px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #94a3b8;
}

.empty-icon {
  font-size: 48px;
  opacity: 0.4;
  margin-bottom: 12px;
}

.empty-text {
  font-size: 14px;
  font-weight: 500;
}

.log-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  overflow: hidden;
  margin-bottom: 10px;
}

.log-body {
  padding: 12px 14px 10px;
}

.log-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 0;
}

.log-row--last {
  padding-bottom: 0;
}

.log-label {
  font-size: 13px;
  color: #94a3b8;
  font-weight: 400;
  flex-shrink: 0;
}

.log-value {
  font-size: 13px;
  color: #475569;
  font-weight: 500;
  text-align: right;
  margin-left: 12px;
  word-break: break-all;
}

.value-ok {
  color: #0d9488;
}

.value-warn {
  color: #ef4444;
}
</style>
